import React from "react";
import twa from "../assets/TWA.jpg";
import SLU from "../assets/SLU-TWA-Logo.jpg";
import TWA from "../assets/TWA-connecting-people.jpg";
import Checker from "../assets/Checker.svg";
import PartnerCard from "../pages/PartnerCard";   

export default function Home() {
  return (
    <main className="font-['farnham-display'] text-[#2b2b2b]">
      <div className="relative">
      
      <img src={twa} alt="background-image" className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover" />
      <div className="absolute inset-0 bg-blue-900 opacity-60"> </div>
         <div className="absolute inset-0 flex items-center justify-center p-4">
      <h1 className="text-[1.25rem] sm:text-[2rem] md:text-[3.25rem] font-bold font-['farnham-display'] text-[#FFF] my-4 text-center">
          Connecting 
          <br/> 
          Justice-Involved Jobseekers and
          <br/> Second Chance Employers
        </h1>
    </div>
  </div>
      <section className="grid py-8 px-0 place-items-center">
        <div className="mx-auto max-w-7xl md:w-5/6 relative px-4">
     <div className="md:grid md:grid-cols-3 md:gap-4 items-center w-full" >
          {/* Image container (on the left on large screens) */}
          <div className="my-8 md:mb-0 grid-cols-1 flex justify-center md:justify-end">
            <img src={SLU} alt= "SLU TWA" className=" objext-contain"/>
          </div>

          {/* Quote text container (on the right on large screens) */}
          <div className="md:col-span-2">
            <p className="text-lg md:text-xl lg:text-2xl py-4 font-['farnham-display'] md:ml-16 text-left text-[#2b2b2b]">
              “Expanding fair chance employment is one of the most effective ways
              to boost economic mobility for justice-involved individuals and build
              safer, more prosperous communities.”
            </p>
          </div>
        </div>

                </div>
      </section>
      {/* --- Second section: Text on the left, image on the right --- */}
        <section className="grid py-8 md:px-0 px-4 place-items-center">
        <div className="mx-auto max-w-7xl bg-[#f0f0f0] md:w-5/6 relative">
        <div className="md:grid md:grid-cols-2 md:gap-8 items-stretch w-full">
          {/* Text container (on the left on large screens) */}
           
          <div className="pl-6 h-full flex items-center">
            <p className="text-base md:text-xl lg:text-2xl xl:text-xl text-left my-4 md:my-20 px-2 font-['corporate-s'] border-l-6 border-[#FFD700] leading-relaxed">
              TWA connects justice-involved individuals with fair-chance employers.
              Also referred to as second-chance employers, these are businesses and
              organizations that are willing to look past the person's record to the
              talent the jobseeker has to offer. Some fair chance employers can hire
              people with any criminal background while others must be more
              selective based on a variety of factors. While TWA is housed at Saint
              Louis University, the program's footprint now expands beyond the St.
              Louis Area to also incorporate collocated services offered pre-release
              at five institutions as well as to individuals going home to the
              metropolitan areas of Kansas City, Springfield, and Columbia.
            </p>
          </div>
          {/* Image container (on the right on large screens) */}
          <div className="mt-4 md:mt-0 h-full flex items-stretch">
            <img
              src={TWA} alt="TWA program Description"
               className="w-full h-full object-cover" />
          </div>
        </div>

        </div> 
      </section>

      <section>
        {/* <div
          className="flex flex-col justify-start items-center bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Checker})` }}
        >
          <PartnerCard /> 
        </div> */}
        <div className="flex flex-col justify-start items-center bg-[#ffff]">
  <PartnerCard />
</div>
      </section>
    </main>
  );
}
